import React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

export interface DescriptionItemProps {
  icon: React.ComponentProps<typeof Icon.Large>['icon']
  title: string
  description: string | JSX.Element
}

const DescriptionItem = ({ icon, title, description }: DescriptionItemProps) => {
  return (
    <Box
      gap="s16"
      alignItems="center"
      justifyContent="center"
      style={{
        flex: '1',
      }}
    >
      <Box
        padding="s16"
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'radicalRed1000',
          },
        }}
        borderRadius={{
          all: 'rel500',
        }}
      >
        <Icon.Large icon={icon} color="radicalRed1000" />
      </Box>
      <Box gap="s8">
        <Text color="grey1000" weight="semibold" size="300">
          {title}
        </Text>
        <Text color="grey1000" weight="normal" size="200" whiteSpace="breakSpaces">
          {description}
        </Text>
      </Box>
    </Box>
  )
}

export default DescriptionItem
